import { makeFetcherBuilder } from '../base';
import { ADMIN_API_URL } from '../../../constants';

export const makeFetcher = makeFetcherBuilder(ADMIN_API_URL);
